import { manageSubscriptionsStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsManageSubscriptions";
import { userInformationStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsUserInformation";
import { changePasswordStyles } from "@insite/content-library/Widgets/ChangePassword/ChangePassword";
import { CheckboxStyle } from "@insite/mobius/Checkbox";
import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
import { InputStyle } from "@insite/mobius/TextField";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

userInformationStyles.userInformationGridItem = {
    width: 12,
    css: css`
    >${FormFieldStyle}{
        >${FormInputWrapper}{
            >${InputStyle}{
                &:disabled{
                    color: ${getColor("secondary")};
                }
            }
        }
    }
    `
}

manageSubscriptionsStyles.manageSubscriptionsTitle = {
    variant: "h4",
    css: css`
    margin-bottom: 0px;
    margin-top: 15px;
    `
}

manageSubscriptionsStyles.manageSubscriptionsCheckbox = {
    typographyProps: {
        css: css`
            margin-left: 10px;
            font-size: 16px;
            color: ${getColor("secondary")};
        `,
    },
}

changePasswordStyles.passwordRequirementsGridItem = {
    width: 12,
    css: css`
    color: ${getColor("secondary")};
    `
}

changePasswordStyles.showPasswordsGridItem = {
    width: 12,
    css: css`
    >${CheckboxStyle}{
        >${TypographyStyle}{
            font-size: 16px;
            color: ${getColor("secondary")};
        }
    }
    `
}